<template>
  <svg
    :key="id"
    :class="className"
    :style="styleObj"
    aria-hidden="true"
    focusable="false"
  >
    <use :xlink:href="url" />
  </svg>
</template>

<script>
const icons = require.context('../../assets/icons', false, /\.svg$/);

export default {
  props: {
    /**
     * The icon filename (without extension) in src/assets/icons
     */
    id: {
      type: String,
      required: true,
    },
    /**
     * Scale (based on a 24x24 size)
     */
    scale: {
      type: Number,
      default: 1,
    },
  },

  computed: {
    url() {
      return icons(`./${this.id}.svg`).default;
    },

    className() {
      return [`icon icon--${this.id}`, { [`icon--${this.size}`]: this.size }];
    },

    styleObj() {
      return {
        width: `${24 * this.scale}px`,
        height: `${24 * this.scale}px`,
      };
    },
  },
};
</script>

<style lang="scss">
.icon {
  display: inline-block;
  vertical-align: middle;
  pointer-events: none;

  position: relative;
  top: -0.1em; // Properly align with text

  fill: currentColor;
  will-change: transform; // Prevent cropped/blurry icons on Firefox
}
</style>
